import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface TableSwitch {
  id: string;
  state: boolean;
}

@Component({
  selector: "app-switch-table",
  templateUrl: "./switch-table.component.html",
  styleUrls: ["./switch-table.component.scss"],
})
export class SwitchTableComponent {
  @Input() onName = "";
  @Input() offName = "";
  @Input() item!: TableSwitch;
  @Input() isDisabled = false;
  @Output() itemChange: EventEmitter<TableSwitch> = new EventEmitter<TableSwitch>();

  changeState() {
    if (!this.isDisabled) {
      this.item.state = !this.item.state;
    }

    this.itemChange.emit(this.item);
  }
}
